// Hiển thị tên + ID + avatar + tag vai trò admin để dễ nhận diện người gửi
import React from "react";
import { Space, Tag, Avatar } from "antd";
import { avatarUrl } from "../helpers";

export default function UserCell({ user }) {
    if (!user) return <span className="text-content-3">—</span>;
    return (
        <Space size={6}>
            <Avatar size={24} src={avatarUrl(user.avatar)}>
                {user.name?.[0]}
            </Avatar>
            <span>
                {user.name || `#${user.userId}`}
                {user.userId != null && (
                    <span className="text-xs text-content-3 ml-1">#{user.userId}</span>
                )}
            </span>
            {user.role === "admin" && <Tag color="gold">admin</Tag>}
        </Space>
    );
}
